"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M5.505 5.199C5.505 3.983 6.49 3 7.705 3H9.94c2.422 0 4.554 1.73 4.554 4.06 0 1.886-1.398 3.38-3.216 3.88l3.104 4.81a.7.7 0 0 1-1.176.76L9.73 11.12H6.905v5.18a.7.7 0 1 1-1.4 0zm1.4 4.521H9.94c1.835 0 3.154-1.278 3.154-2.66S11.776 4.4 9.941 4.4H7.705c-.443 0-.8.358-.8.799z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=CurrencySouthAfricanRandIcon20.js.map